import { render, staticRenderFns } from "./statisticsResource.vue?vue&type=template&id=641c0bed&scoped=true&"
import script from "./statisticsResource.vue?vue&type=script&lang=js&"
export * from "./statisticsResource.vue?vue&type=script&lang=js&"
import style0 from "./statisticsResource.vue?vue&type=style&index=0&id=641c0bed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c0bed",
  null
  
)

export default component.exports